import React from 'react';

const CONFIG = {
  approved: { cls: 'badge-approved', dot: '#52B788' },
  pending:  { cls: 'badge-pending',  dot: '#D97706' },
  rejected: { cls: 'badge-rejected', dot: '#EF4444' },
};

export function StatusBadge({ status }) {
  const c = CONFIG[status] || CONFIG.pending;
  return (
    <span className={c.cls}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: c.dot, display: 'inline-block', flexShrink: 0 }} />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
